import { createClient } from "contentful";

export const client = createClient({
  space: "0uzeny1y5a1z",
  environment: "master", // defaults to 'master' if not set
  accessToken: process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN,
});